module.exports = "<div class=\"testata\">\n    <img class=\"logo\" alt=\"Logo\" [src]=\"logo\">\n</div>\n<ngx-spinner size=\"large\"><p>Attendere</p></ngx-spinner>\n<div class=\"error_message\">\n  <h3>{{message}}</h3>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/andrea/Documents/Projects/SW40/landing-portale-privacy/src/app/confirm-page/confirm-page.component.html
// module id = ../../../../../src/app/confirm-page/confirm-page.component.html
// module chunks = main